/* global attachEvent, videoiFrameElement */

// *******************************************************************************
// 1.0 - Open lightbox
// *******************************************************************************

const lightboxTrigger = document.querySelectorAll('.light-box-button');

Array.prototype.forEach.call(lightboxTrigger, (element) => {
  element.addEventListener('click', (ev) => {
    const id = ev.currentTarget.getAttribute('data-modal');
    if (document.getElementById(id)) {
      document.getElementById(id).classList.add('is-modal-open');
    }
    ev.preventDefault();
  });
});

// *******************************************************************************
// 2.0 - Close lightbox
// *******************************************************************************

attachEvent('.light-box-single .close-button', 'click', (ev) => {
  ev.preventDefault();
  ev.target.closest('.light-box-single').classList.remove('is-modal-open');
  videoiFrameElement.src = '';
});
